import { marsToBaidu } from "../../utils";
import { AREA_DIR, AREA_MODE, AREA_TICKET_TYPE } from "../../const/area";
import dayjs from "dayjs";

// 获取日期和时段
// dateTime格式：`${date}__${time}`
export function getDateAndTime(dateTime) {
  if (typeof dateTime !== 'string' || !dateTime || !dateTime.includes('__')) {
    return null
  }
  const [date, time] = dateTime.split('__')
  return {
    date,
    time
  }
}

// 获取选择人数列表
export function getPassengerPickerData({userNum, minUserNum}) {
  function getList(len) {
    const list = []
    for(let i = 1; i <= len; i++) {
      const item = {
        label: i + '人',
        value: i
      }
      if (typeof minUserNum === 'number') {
        if (i >= minUserNum) {
          list.push(item)
        }
      } else {
        list.push(item)
      }
    }
    return list
  }
  return getList(userNum)
}

export function gcjToBd(stop) {
  const {lng, lat} = stop || {}
  if (!lng || !lat) return {}
  const { lng: _lng, lat: _lat } = marsToBaidu(lng, lat);
  return {
    lng: _lng,
    lat: _lat,
    originLng: lng,
    originLat: lat
  }
}

/**
 * 
 * @param {*} isHubArea 是否枢纽站模式
 * @param {*} isHubArea 是否枢纽站模式
 * @param {*} innerStops 区域内的站点列表（原模式下，上下车站点都在里面；枢纽站模式下，只有上或下车站点在里面）
 * @param {*} hubStops 枢纽站站点列表（枢纽站模式下，只有上或下车站点在里面）暂时只支持一个枢纽站
 */
export function findStop(stopId, {isHubArea, innerStops, hubStops}) {
  const iStops = innerStops || []
  const hStops = hubStops || []
  const allStops = [...iStops, ...hStops]
  if (isHubArea) {
    return allStops.find(item => item.id === stopId)
  } else {
    return iStops.find(item => item.id === stopId)
  }
}

/**
 * 枢纽站模式
 * 往枢纽站方向(direction: 0): 上车点onStops需要从区域内选择，下车点固定为offStops(只有一项即枢纽站)
 * 从枢纽站出发(direction: 1): 上车点固定为onStops(只有一项即枢纽站)，下车点offStops需要从区域内选择
 */

/**
 * 获取枢纽站站点
 */
export function getHubStops(direction, onStops, offStops) {
  if (direction === AREA_DIR.FROM_HUB) {
    return onStops.map((item) => ({ 
      ...item,
      ...gcjToBd(item)
    }));
  }
  if (direction === AREA_DIR.TO_HUB) {
    return offStops.map((item) => ({
      ...item,
      ...gcjToBd(item)
    }));
  }
  return [];
}

/**
 * 获取区域内站点
 */
export function getInnerStops(direction, onStops, offStops) {
  if (direction === AREA_DIR.FROM_HUB) {
    return offStops.map((item) => ({ 
      ...item,
      ...gcjToBd(item)
    }));
  }
  if (direction === AREA_DIR.TO_HUB) {
    return onStops.map((item) => ({
      ...item,
      ...gcjToBd(item)
    }));
  }
  return [];
}

/**
 * 格式化站点数据
 */
export function formatReactiveLineStops(pid, stops) {
  return (stops || [])
    .filter((p) => !!p)
    .map((stop) => {
      const {
        id,
        lng,
        lat,
        name,
        price,
        reactiveLineStopSectionTickets = [],
        mode,
        isHub,
        originLat,
        originLng
      } = stop || {};
      return {
        pid,
        id,
        lng,
        lat,
        name,
        price,
        priceList: (reactiveLineStopSectionTickets || []).map((o) => {
          let { orderNum: level, price, singalNum: num } = o || {};
          return {
            level,
            price,
            num,
          };
        }),
        isHubArea: mode === AREA_MODE.HUB,
        isHubStop: isHub === 1,
        originLng,
        originLat
      };
    });
}

/**
 * 区域内站点（地图）
 */
export function getReactiveLineStops({
  pid,
  mode,
  reactiveLineStops,
  direction,
  onStops,
  offStops,
}) {
  if (mode === AREA_MODE.HUB) {
    return formatReactiveLineStops(
      pid,
      [...getInnerStops(direction, onStops, offStops), ...getHubStops(direction, onStops, offStops)]
    );
  }
  const stops = (reactiveLineStops || []).map(item => {
    return {
      ...item,
      ...gcjToBd(item)
    }
  })
  return formatReactiveLineStops(pid, stops);
}

/**
 * 获取运营时间
 */
export function getRunTime(validTime) {
  let startRunTime = "";
  let endRunTime = "";
  const timeRangeList = [];
  const arr = (validTime || "").split(";");
  if (arr.length) {
    arr.forEach((item) => {
      timeRangeList.push({
        startTime: item.split("-")[0],
        endTime: item.split("-")[1],
      });
    });
    startRunTime = timeRangeList[0].startTime;
    endRunTime = timeRangeList[timeRangeList.length - 1].endTime;
  }
  return {
    startRunTime,
    endRunTime,
    timeRangeList
  };
}

/**
 * 枢纽站模式，预约单时间段
 */
export function getPreTimeList(ticketType, preValidTime) {
  if (ticketType !== AREA_TICKET_TYPE.BOOKING_ORDER) return [];
  const { validTimes } = preValidTime || {};
  return validTimes || [];
}

/**
 * 检查该区域是否为枢纽站模式
 */
export function checkIsHubArea(mode) {
  return mode === AREA_MODE.HUB;
}

/**
 * 枢纽站模式下，检查是否为预约单
 */
export function checkIsBookingTicket(ticketType) {
  return ticketType === AREA_TICKET_TYPE.BOOKING_ORDER;
}

/**
 * 检查是否跨天
 * startTime晚于endTime,则判断为跨天
 */
export function checkIsCrossDay(startTime, endTime) {
  if (!startTime || !endTime) return false
  const timeFormat = 'HH:mm'
  let currTime = dayjs();
  let prefix = currTime.format('YYYY-MM-DD');
  const start = dayjs(prefix + startTime, {format: timeFormat})
  const end = dayjs(prefix + endTime, {format: timeFormat})
  return start.isAfter(end)
}
